import { ComponentProps } from 'react';
import clsx from 'clsx';
import Tooltip from 'components/Tooltip';
import EyeOpenImg from 'assets/common/eye-open.svg?react';

type Props = ComponentProps<'svg'> & {
  tooltip: string;
  qaSelector?: string;
};

function RevealIcon({ tooltip, qaSelector, className, ...rest }: Props) {
  const iconClassName = clsx('cursorPointer', className);

  return (
    <Tooltip title={`Reveal ${tooltip}`} placement='bottom' arrow={false}>
      <EyeOpenImg
        data-qa-selector={qaSelector}
        className={iconClassName}
        {...rest}
      />
    </Tooltip>
  );
}

export default RevealIcon;
